import { useLocation } from "react-router-dom";

function useQueryRefNav() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  return queryParams.get("ref") === "nav";
}

export default useQueryRefNav;
